import type { BlockField } from '@/blocks/domain/types';

import { getDefaultFieldsForDocumentType, type FieldKind } from '@/blocks/domain/helpers/defaultFieldsRegistry';

/**
 * Default field templates for the three field-based block kinds. Mirrors the
 * `defaultFieldsFor` helper in raptor-crm-poc verbatim (token strings, widths,
 * styles) so freshly-created blocks look identical across the two stacks.
 */
export function defaultFieldsFor(kind: FieldKind, documentTypeKey?: string | null): BlockField[] {
  const defaults = getDefaultFieldsForDocumentType(documentTypeKey);
  return defaults[kind];
}
